// Mobile sticky ATC: shows once the real ATC button leaves the viewport, no scroll listeners
function initCmStickyAtc() {
  var bar = document.querySelector('[data-cm-sticky-atc]');
  // sold-out PDPs emit no product form, so the notify slot is what has to leave the viewport instead
  var target = document.querySelector('.product-form__submit') || document.querySelector('.cm-buybox-notify');
  if (!bar || !target || !('IntersectionObserver' in window)) return;

  var mq = window.matchMedia('(max-width: 989px)');

  var observer = new IntersectionObserver(
    function (entries) {
      var entry = entries[0];
      bar.classList.toggle('cm-sticky-atc--visible', mq.matches && !entry.isIntersecting);
    },
    { threshold: 0 }
  );
  observer.observe(target);

  mq.addEventListener('change', function (event) {
    if (!event.matches) bar.classList.remove('cm-sticky-atc--visible');
  });

  // owner ruling: the bar shows from the first visit and stacks ABOVE the cookie banner, so it rides on the banner's live height
  var lastOffset = null;
  function syncBanner() {
    var banner = document.getElementById('shopify-pc__banner') || document.querySelector('.shopify-pc__banner');
    var height = banner && banner.offsetHeight > 0 ? Math.round(banner.getBoundingClientRect().height) : 0;
    var offset = height + 'px';
    // writing an unchanged value would still emit a mutation record and re-enter this observer
    if (offset === lastOffset) return;
    lastOffset = offset;
    bar.style.setProperty('--cm-sticky-atc-offset', offset);
  }
  syncBanner();
  window.addEventListener('resize', syncBanner);
  if ('MutationObserver' in window) {
    new MutationObserver(syncBanner).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCmStickyAtc);
} else {
  initCmStickyAtc();
}
